import { styled } from "@mui/material";
import React, { useState } from "react";
import { ReactComponent as RoleIcon } from '../../../../svg/adminRoleIcon.svg';
import { ReactComponent as Arrow } from '../../../../svg/arrow.svg';
import SettingsModal from '../Modal/settingsCustomModal';
import QualificationOptions from "./QualificationOptions";
import QualificationDetails from "./QualificationDetails";
import UpdateQualification from "./UpdateQualification";
import DeleteQualification from "./DeleteQualification";

interface QualificationResponse {
    StatusCode: number;
    Message: string;
    Data: Qualification[];
  }
  
  interface Qualification {
    id: number;
    QualificationId: number;
    QualificationName: string;
    Score: number;
    CreatedBy: string;
    ModifiedBy: string;
    CreateDate: string;
    LastModified: string;
    ActiveStatus: boolean;
    IsApprovalRequired: boolean;
    LevelBy: number;
    ApprovalTypeId: number;
    IsDeleted: boolean;
  }

interface ComponentProps {
    qualification: QualificationResponse | undefined;
}

const QualificationContent: React.FC<ComponentProps> = ({ qualification }) => {
    const [qualificationName, setQualificationName] = useState('');
    const [id, setId] = useState(0);
    const [createdDate, setCreatedDate] = useState('');
    const [openQualificationDetails, setOpenQualificationDetails] = useState(false);
    const [openUpdateQualificationModal, setOpenUpdateQualificationModal] = useState(false);
    const [openDeleteQualificationModal, setOpenDeleteQualificationModal] = useState(false);

    const handleOpenQualificationDetails = () => setOpenQualificationDetails(true);
    const handleCloseQualificationDetails = () => setOpenQualificationDetails(false);

    const handleOpenUpdateQualificationModal = () => setOpenUpdateQualificationModal(true);
    const handleCloseUpdateQualificationModal = () => setOpenUpdateQualificationModal(false);

    const handleOpenDeleteQualificationModal = () => setOpenDeleteQualificationModal(true);
    const handleCloseDeleteQualificationModal = () => setOpenDeleteQualificationModal(false);

    function convertDate(dateString: string){
        if(!dateString) return;
        let p = dateString?.split(/\D/g)
        return [p[0], p[1], p[2]].join("-");
    };

    const handleOpen = (qualification: Qualification) => {
        setQualificationName(qualification?.QualificationName);
        setId(qualification?.id);
        setCreatedDate(qualification?.CreateDate);
        handleOpenQualificationDetails();
    }

    const handleDelete = () => {
        handleCloseQualificationDetails();
        handleOpenDeleteQualificationModal();
    };
    
    const handleUpdate = () => {
        handleCloseQualificationDetails();
        handleOpenUpdateQualificationModal();
    };

    return (
        <StyledContainer>
            <TotalWrapper>
                <span>Total</span>
                <TotalNumberStyle>{qualification?.Data?.length}</TotalNumberStyle>
            </TotalWrapper>
            {qualification?.Data && qualification?.Data?.length > 0 &&
                qualification?.Data?.map((data) => (
                <RoleWrapper onClick={() => handleOpen(data)} key={data?.LevelBy}>
                    <div>
                        <RoleIconWrapper><RoleIcon /></RoleIconWrapper>
                        <RoleText>{data?.QualificationName}</RoleText>
                        <Active>{data?.ActiveStatus === true ? 'Active' : 'Disabled'}</Active>
                        <DateWrapper>{convertDate(data?.CreateDate)}</DateWrapper>
                    </div>
                    <ArrowIconWrapper>
                        <Arrow />
                    </ArrowIconWrapper>
                </RoleWrapper>
            ))}

            <SettingsModal 
                open={openQualificationDetails}
                cancel={handleCloseQualificationDetails}
                maxWidth='712px'
                header={qualificationName && qualificationName}
                content={<QualificationDetails createdDate={convertDate(createdDate)} qualificationName={qualificationName} />}
                card={<QualificationOptions 
                    handleUpdate={handleUpdate} 
                    handleDelete={handleDelete}
                />}
            />

            <SettingsModal
                open={openUpdateQualificationModal}
                cancel={handleCloseUpdateQualificationModal}
                maxWidth='480px'
                header='Update Qualification'
                showrightIcon={false}
                content={<UpdateQualification 
                    qualificationName={qualificationName} 
                    handleClose={handleCloseUpdateQualificationModal} 
                    id={id}
                />}   
            />

            <SettingsModal
                open={openDeleteQualificationModal}
                cancel={handleCloseDeleteQualificationModal}
                maxWidth='536px'
                header='Delete Qualification'
                showrightIcon={false}
                content={<DeleteQualification 
                    qualificationId={id} 
                    handleClose={handleCloseDeleteQualificationModal} 
                    qualificationName={qualificationName}
                />}   
            />
        </StyledContainer>     
    )
}

export default QualificationContent;

const StyledContainer = styled('div')`
    margin-block: 3.8rem;
    margin-inline: 3.5rem;
`

const TotalNumberStyle = styled('span')`
    background-color: #F1F3F4;
    border-radius: 0.2rem;
    margin-inline-start: 0.4rem;
    padding-inline: 0.2rem;
`

const TotalWrapper = styled('div')`
    color: #4E5A62;
    font-weight: 500;
`

const RoleWrapper = styled('div')`
    display: flex;
    justify-content: space-between;
    border: 0.1rem solid #E1E1E1;
    margin-block: 0.6rem;
    padding-inline: 1.2rem;
    padding-block: 1.2rem;
    border-radius: 0.5rem;
    width: 100%;
    text-align: left;
    background-color: transparent;
`

const RoleIconWrapper = styled('span')`
    background-color: #FFF4DE;
    border-radius: 0.1rem;
    padding-inline: 0.4rem;
`

const RoleText = styled('span')`
    font-weight: 600;
    font-size: 16px;
    margin-inline: 0.8rem;
`

const Active = styled('span')`
    font-size: 14px;
    font-weight: 500;
    background-color: #E0FAEE;
    border-radius: 0.4rem;
    padding-inline: 0.5rem;
    color: #11643C;
`

const DateWrapper = styled('div')`
    margin-block-start: 0.8rem;
`

const ArrowIconWrapper = styled('div')`
    display: flex;
    flex-direction: column;
    justify-content: center;
`